import { ADD_TEMPLATE, ADD_TEMPLATE_FAILED, ADD_TEMPLATE_SUCCESS, DELETE_TEMPLATE, DELETE_TEMPLATE_FAILED, DELETE_TEMPLATE_SUCCESS, EDIT_TEMPLATE, EDIT_TEMPLATE_FAILED, EDIT_TEMPLATE_SUCCESS, GET_TEMPLATE, GET_TEMPLATE_FAILED,
     GET_TEMPLATE_SUCCESS, TEMPLATE_DETAILS, TEMPLATE_DETAILS_FAILED, TEMPLATE_DETAILS_SUCCESS, TEMPLATE_PREVIEW, 
     TEMPLATE_PREVIEW_FAILED, TEMPLATE_PREVIEW_SUCCESS, GET_TEMPLATE_DATA,GET_TEMPLATE_DATA_SUCCESS,GET_TEMPLATE_DATA_FAIL } from "./actionTypes"


export const templateDetails = (payload) => {
    return {
        type: TEMPLATE_DETAILS,
        payload: payload
    }
}

export const templateDetailsSuccess = (payload) => {
    return {
        type: TEMPLATE_DETAILS_SUCCESS,
        payload: payload
    }
}



export const templateDetailsFailed = (payload) => {
    return {
        type: TEMPLATE_DETAILS_FAILED,
        payload: payload
    }
}


export const addTemplate = (payload) => {
    return {
        type: ADD_TEMPLATE,
        payload: payload
    }
}

export const addTemplateSuccess = (payload) => {
    console.log(payload)
    return {
        type: ADD_TEMPLATE_SUCCESS,
        payload: payload
    }
}



export const addTemplateFailed = (payload) => {
    return {
        type: ADD_TEMPLATE_FAILED,
        payload: payload
    }
}

export const editTemplate = (payload) => {
    return {
        type: EDIT_TEMPLATE,
        payload: payload
    }
}

export const editTemplateSuccess = (payload) => {
   
    return {
        type: EDIT_TEMPLATE_SUCCESS,
        payload: payload
    }
}



export const editTemplateFailed = (payload) => {
    return {
        type: EDIT_TEMPLATE_FAILED,
        payload: payload
    }
}

export const getTemplateDetail = (payload) => {
    return {
        type: GET_TEMPLATE,
        payload: payload
    }
}

export const getTemplateDetailSuccess = (payload) => {
   
    return {
        type: GET_TEMPLATE_SUCCESS,
        payload: payload
    }
}



export const getTemplateDetailFailed = (payload) => {
    return {
        type: GET_TEMPLATE_FAILED,
        payload: payload
    }
}

export const deleteTemplate = (payload) => {
    return {
        type: DELETE_TEMPLATE,
        payload: payload
    }
}

export const deleteTemplateSuccess = (payload) => {
   
    return {
        type: DELETE_TEMPLATE_SUCCESS,
        payload: payload
    }
}



export const deleteTemplateFailed = (payload) => {
    return {
        type: DELETE_TEMPLATE_FAILED,
        payload: payload
    }
}

export const getTemplatePreview = (payload) => {
    return {
        type: TEMPLATE_PREVIEW,
        payload: payload
    }
}

export const getTemplatePreviewSuccess = (payload) => {
    return {
        type:TEMPLATE_PREVIEW_SUCCESS,
        payload: payload
    }
}



export const getTemplatePreviewFailed = (payload) => {
    return {
        type: TEMPLATE_PREVIEW_FAILED,
        payload: payload
    }
}

export const getTemplateData = (id)=>{
    return{
        type: GET_TEMPLATE_DATA,
        payload: id
    }
}


export const getTemplateDataSuccess = (data)=>{
    return{
        type: GET_TEMPLATE_DATA_SUCCESS,
        payload: data
    }
}

export const getTemplateDataFail = (data)=>{
    return{
        type: GET_TEMPLATE_DATA_FAIL,
        payload: data
    }
}
